import React from 'react';
import { Navigate } from 'react-router-dom';
import ErrorServicePage from '../features/Comprar/salud-flexible/error-service';

const routersApiCanal = Array(30).fill(0).map(
  (_, index) => index.toString().padStart(3, '0'),
);
const codesApiCanal = Array(9).fill(0).map(
  (_, index) => index.toString().padStart(2, '0'),
);

export const otherRoutes = (isLogged) => {
  const routes = [];
  routersApiCanal.forEach((apiId) => {
    codesApiCanal.forEach((code) => {
      routes.push({
        path: `/comprar/seguro-salud-flexible/page-error-${apiId}-${code}`,
        element: isLogged ? <ErrorServicePage /> : <Navigate to="/comprar/seguro-salud-flexible" replace />,
      });
    });
  });
  return routes;
};
